// developed by Param Partap Singh
import React from 'react'
import '../Css/Footer.css'

export default function Footer() {
  return (
    <div className='footer-main'>
      <p>Designed by IT Team</p>
    </div>
  )
}
